import { AriaRole } from 'react';
import type { Types } from '@fiverr-private/theme';
import type { TagProps } from './types';

export const getElement = (
    href: TagProps['href'],
    hasClickEvent: boolean,
    clickableArea: TagProps['clickableArea']
): { element: Types.BoxType['as']; role?: AriaRole; tabIndex?: TagProps['tabIndex'] } => {
    if (href) {
        return {
            element: 'a',
            role: 'link',
        };
    }

    if (hasClickEvent && clickableArea === 'tag') {
        return {
            element: 'button',
            role: 'button',
        };
    }

    return {
        element: 'div',
        ...(hasClickEvent && clickableArea === 'multi'
            ? {
                  role: 'button',
                  tabIndex: 0,
              }
            : {}),
    };
};
